const config: PageConfigurationType = {
    breadCrumbs: [{ label: 'home', path: 'home' }, 'required_documents']
}

export default config
